import React from 'react';

function SvgEtagere() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 140.3 492.86"
      className="meuble etagere"
    >
      <defs>
        <style>
          {
            ".etagere_svg__etagere .etagere_svg__cls-3{fill:#efede8}.etagere_svg__etagere .etagere_svg__cls-4{fill:#3db2e7}.etagere_svg__etagere .etagere_svg__cls-5{fill:#14c1a0}.etagere_svg__etagere .etagere_svg__cls-6{fill:#96d320}.etagere_svg__etagere .etagere_svg__cls-8{fill:#f76b96}.etagere_svg__etagere .etagere_svg__cls-9{fill:#e55187}.etagere_svg__etagere .etagere_svg__cls-13{fill:#0fa588}.etagere_svg__etagere .etagere_svg__cls-14{fill:#a0e9ef}.etagere_svg__etagere .etagere_svg__cls-15{fill:#72d1d3}.etagere_svg__etagere .etagere_svg__cls-17{fill:#bc8050}.etagere_svg__etagere .etagere_svg__cls-18{fill:#ce945f}.etagere_svg__etagere .etagere_svg__cls-20{fill:#eab68b}.etagere_svg__etagere .etagere_svg__cls-21{fill:#fcd8be}.etagere_svg__etagere .etagere_svg__cls-22{fill:#050505}"
          }
        </style>
      </defs>
      <g
        id="etagere_svg__Calque_2"
        className="etagere_svg__etagere meuble"
        data-name="Calque 2"
      >
        <g id="etagere_svg__Calque_1-2" data-name="Calque 1">
          <path
            className="etagere_svg__cls-1"
            opacity={0.1}
            d="M10 0h130.3v492.86H10z"
          />
          <path
            className="etagere_svg__cls-2"
            fill="#fff"
            d="M0 0h130.3v492.86H0z"
          />
          <path
            className="etagere_svg__cls-3"
            d="M12.77 14.05h104.77v104.77H12.77zM12.77 134.05h104.77v104.77H12.77zM12.77 254.05h104.77v104.77H12.77zM12.77 374.05h104.77v104.77H12.77z"
          />
          <path
            className="etagere_svg__cls-4"
            d="M110.73 229.58a7.85 7.85 0 01-7.85 7.85H27.42a7.84 7.84 0 01-7.84-7.85 7.84 7.84 0 017.84-7.84h75.46a7.85 7.85 0 017.85 7.84z"
          />
          <path
            className="etagere_svg__cls-5"
            d="M100 214a7.63 7.63 0 01-7.39 7.85H37.69a7.64 7.64 0 01-7.4-7.85 7.64 7.64 0 017.4-7.85h54.93A7.63 7.63 0 01100 214z"
          />
          <path
            className="etagere_svg__cls-6"
            d="M91.86 198.29a7.63 7.63 0 01-7.39 7.84H45.84a7.63 7.63 0 01-7.4-7.84 7.63 7.63 0 017.4-7.85h38.63a7.63 7.63 0 017.39 7.85z"
          />
          <path
            className="etagere_svg__cls-7"
            d="M84.32 182.56c0 4.35-3.79 7.88-8.45 7.88H54.44a8.18 8.18 0 01-8.44-7.88 8.18 8.18 0 018.45-7.89h21.42a8.19 8.19 0 018.45 7.89z"
            fill="#e2d347"
          />
          <path
            className="etagere_svg__cls-8"
            d="M76.77 166.82c0 4.34-2.9 7.85-6.49 7.85H60c-3.58 0-6.49-3.51-6.49-7.85 0-4.33 2.91-7.84 6.49-7.84h10.28c3.59 0 6.49 3.51 6.49 7.84zM12.77 276.4h13.39v82.42H12.77z"
          />
          <path
            className="etagere_svg__cls-9"
            d="M12.77 283.34h13.39v6.75H12.77z"
          />
          <path
            className="etagere_svg__cls-10"
            fill="#b59fc6"
            d="M26.16 292.73h13.39v66.08H26.16z"
          />
          <path
            className="etagere_svg__cls-11"
            fill="#9b83b2"
            d="M26.16 298.3h13.39v6.77H26.16z"
          />
          <path
            className="etagere_svg__cls-6"
            d="M39.55 267.06h8.98v91.75h-8.98z"
          />
          <path
            className="etagere_svg__cls-12"
            fill="#8aba13"
            d="M39.55 274.79h8.98v7.52h-8.98z"
          />
          <path
            className="etagere_svg__cls-5"
            d="M48.53 283.34h13.39v75.48H48.53z"
          />
          <path
            className="etagere_svg__cls-13"
            d="M48.53 289.69h13.39v7.73H48.53z"
          />
          <path
            className="etagere_svg__cls-14"
            d="M61.92 287.9h8.98v70.92h-8.98z"
          />
          <path
            className="etagere_svg__cls-15"
            d="M61.92 293.87h8.98v5.81h-8.98z"
          />
          <path
            className="etagere_svg__cls-4"
            d="M70.9 276.4h13.39v82.42H70.9z"
          />
          <path
            className="etagere_svg__cls-16"
            fill="#24a2ce"
            d="M70.9 283.34h13.39v6.75H70.9z"
          />
          <path
            className="etagere_svg__cls-8"
            d="M84.29 292.73h13.39v66.08H84.29z"
          />
          <path
            className="etagere_svg__cls-9"
            d="M84.29 298.3h13.39v6.77H84.29z"
          />
          <path
            className="etagere_svg__cls-14"
            d="M97.68 267.06h8.98v91.75h-8.98z"
          />
          <path
            className="etagere_svg__cls-15"
            d="M97.68 274.79h8.98v7.52h-8.98z"
          />
          <path
            className="etagere_svg__cls-5"
            d="M106.66 283.34h10.88v75.48h-10.88z"
          />
          <path
            className="etagere_svg__cls-13"
            d="M106.66 289.69h10.88v7.73h-10.88z"
          />
          <path
            className="etagere_svg__cls-17"
            d="M53 80.89s-9.25 1.42-17.55 11.41S23 111.05 27.4 115.63c2.89 3 10.86 3 13.24-3.61 1.07-3 2-9 4.78-14a36.68 36.68 0 015.34-7.68zM75.28 80.89s9.27 1.42 17.57 11.41 12.41 18.75 8.05 23.33c-2.89 3-10.85 3-13.24-3.61-1.07-3-2-9-4.78-14a36.68 36.68 0 00-5.34-7.68z"
          />
          <path
            className="etagere_svg__cls-18"
            d="M71.51 76.09l-7 1.57-7-1.57s-21.24 17.8-17.78 35.58 24.41 18.24 24.41 18.24h.76s20.94-.46 24.41-18.24-17.8-35.58-17.8-35.58z"
          />
          <path
            className="etagere_svg__cls-19"
            d="M81.31 108.21a17.58 17.58 0 11-17.58-17.58 17.58 17.58 0 0117.58 17.58z"
            fill="#d89d6c"
          />
          <path
            className="etagere_svg__cls-20"
            d="M58.62 116.75c5.37 5.36 6.2 13.24 1.84 17.6s-12.23 3.53-17.6-1.84-6.19-13.25-1.84-17.6 12.23-3.53 17.6 1.84z"
          />
          <path
            className="etagere_svg__cls-21"
            d="M55.88 119.49c3.5 3.5 4 8.64 1.2 11.47s-8 2.3-11.48-1.2-4-8.63-1.19-11.47 7.97-2.29 11.47 1.2z"
          />
          <path
            className="etagere_svg__cls-20"
            d="M85.86 132.51c-5.37 5.37-13.25 6.19-17.6 1.84s-3.53-12.24 1.84-17.6 13.25-6.2 17.6-1.84 3.53 12.23-1.84 17.6z"
          />
          <path
            className="etagere_svg__cls-21"
            d="M83.12 129.76c-3.5 3.5-8.64 4-11.48 1.2s-2.3-8 1.2-11.47 8.64-4 11.48-1.2 2.3 7.97-1.2 11.47z"
          />
          <path
            className="etagere_svg__cls-18"
            d="M96.55 50.1a9.51 9.51 0 00-14.43-8.16 25.11 25.11 0 00-35.85-.15A9.52 9.52 0 1039 59.13v.32a25.11 25.11 0 0050.22 0v-.1a9.5 9.5 0 007.33-9.25z"
          />
          <path
            className="etagere_svg__cls-22"
            d="M57 62.91a2 2 0 11-2-2.42 2.25 2.25 0 012 2.42zM75.11 62.91a2 2 0 11-2-2.42 2.24 2.24 0 012 2.42z"
          />
          <path
            className="etagere_svg__cls-20"
            d="M76.65 70.63c-2.28-5.56-10.18-7.26-12.92-7.29s-9.95 1.73-12.24 7.29c-2.65 6.44 6.84 10.59 12.58 10.59 5.54 0 15.23-4.15 12.58-10.59z"
          />
          <path
            className="etagere_svg__cls-22"
            d="M64.07 64.65c-1.17 0-4.33.54-4.33 2.64 0 1.85 3.12 3.58 4.33 3.81 1.21-.23 4.33-2 4.33-3.81 0-2.1-3.16-2.64-4.33-2.64zM73.63 72.61c-.06.28-1.6 6.49-9.19 6.27h-.73c-7.58.22-9.12-6-9.19-6.27l-.72.15a9.43 9.43 0 009.53 6.81h1.51a9.45 9.45 0 009.53-6.81z"
          />
          <path d="M63.73 71.1h.69v8.47h-.69z" />
          <path
            className="etagere_svg__cls-20"
            d="M43.53 45.42s-5.77-1.8-7.08 2.34c-1.58 5 3.61 6.84 3.61 6.84zM84.73 45.42s5.77-1.8 7.07 2.34c1.59 5-3.61 6.84-3.61 6.84z"
          />
          <path
            className="etagere_svg__cls-23"
            fill="#e0d3bd"
            d="M12.77 379.4h104.77v99.42H12.77z"
          />
          <path
            className="etagere_svg__cls-24"
            d="M85.28 399.06a6.66 6.66 0 01-6.66 6.66H51.69a6.66 6.66 0 01-6.69-6.66 6.66 6.66 0 016.66-6.66h26.96a6.66 6.66 0 016.66 6.66z"
            fill="#ceb99b"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgEtagere;
